import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-account-activation',
  templateUrl: './account-activation.component.html',
  styleUrls: ['./account-activation.component.css'],
  providers: [MessageService]
})
export class AccountActivationComponent implements OnInit {
  activationStatus: 'loading' | 'success' | 'error' = 'loading';
  errorMessage: string = '';
  clientType: 'company' | 'merchant' = 'company';
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    // Determine client type from URL path
    const url = this.router.url;
    this.clientType = url.includes('/company/') ? 'company' : 'merchant';
    
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      
      if (token) {
        this.activateAccount(token);
      } else {
        this.activationStatus = 'error';
        this.errorMessage = 'Token d\'activation manquant. Veuillez vérifier votre lien d\'activation.';
      }
    });
  }

  private activateAccount(token: string): void {
    this.authService.activateAccount(token, this.clientType as 'company' | 'merchant').subscribe({
      next: (response) => {
        this.activationStatus = 'success';
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: 'Votre compte a été activé avec succès!',
          life: 5000
        });
      },
      error: (error) => {
        this.activationStatus = 'error';
        this.errorMessage = error?.error?.message || 'Une erreur est survenue lors de l\'activation de votre compte.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.errorMessage,
          life: 5000
        });
      }
    });
  }

  navigateToLogin(): void {
    this.router.navigate([`/${this.clientType}/signin`]);
  }
}
